module.exports = __webpack_public_path__ + "static/media/alzucar.92835e8e.png";